import React from 'react';
import { IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { TP_COLORS } from '../../../../constants';
import { getSubjectColor } from '../../../../helper';
import { whiteButtonStyles } from '../../../../components/Button/styles';

export interface SubmissionsJumboTronprops {
  subject: string;
  curriculum: string;
  grade: string;
  onBack?: () => void;
}

const SubmissionsJumboTron: React.FC<SubmissionsJumboTronprops> = ({
  subject,
  curriculum,
  grade,
  onBack,
}) => {
  return (
    <div
      style={{
        marginBottom: '30px',
        padding: '0 5%',
        background: `url('${
          process.env.PUBLIC_URL
        }images/shapes/learning-gadgets.transparent.png') top right/contain no-repeat, ${getSubjectColor(
          subject
        )}`,
      }}
    >
      {Boolean(onBack) && (
        <div
          style={{
            padding: '30px',
            marginBottom: '-100px',
            marginLeft: '-5%',
          }}
        >
          <IconButton onClick={onBack} sx={whiteButtonStyles}>
            <ArrowBackIcon />
          </IconButton>
        </div>
      )}
      <div
        style={{
          padding: '30px',
          background: `url('${process.env.PUBLIC_URL}/images/shapes/square-pieces-transparent.png') 20%/contain no-repeat`,
        }}
      >
        <Typography component="h1" variant="h4" sx={{ color: TP_COLORS.white }}>
          {subject}
        </Typography>
        <Typography
          variant="h6"
          fontWeight={600}
          sx={{ color: TP_COLORS.white, opacity: 0.5 }}
        >
          {curriculum}
        </Typography>
        <Typography
          variant="h6"
          fontWeight={600}
          sx={{ color: TP_COLORS.white, opacity: 0.5 }}
        >
          {grade}
        </Typography>
      </div>
    </div>
  );
};

export default SubmissionsJumboTron;
